export default function dateFilter (value) {
  if (value) {
    const time = new Date(value * 1000).toLocaleDateString()
    return time
  }
}
